import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'answerFilter'
})
export class AnswerFilterPipe implements PipeTransform {

  transform(value: any, trueAnswer: string[]): string {

    let color: string;

    switch (value) {
      case 0:
        value = 'A'

        break;
      case 1:
        value = 'B'

        break;
      case 2:
        value = 'C'

        break;
      case 3:
        value = 'D'
        break;
    
      default:
        break;
    }


    let opacity: string;
    
    if (trueAnswer.includes(value)) {
      color = "text-green-300";
    } else {
      color = "text-gray-300";
    }
    return color;
  }

}
